<template>
  <v-container fluid>
    <div class="d-block d-md-flex">
      <AppAside></AppAside>
      <div class="ps-5 page_content grow">
        <v-card elevation="4" rounded="xl" class="gift-form-card">
          <!-- Header -->
          <div class="form-header pa-6 pb-4">
            <div class="d-flex align-center">
              <div class="header-icon-wrapper me-4">
                <v-icon large color="white">
                  {{ $route.params.id ? 'mdi-gift' : 'mdi-plus-circle' }}
                </v-icon>
              </div>
              <div>
                <h1 class="text-h5 font-weight-bold white--text mb-1">
                  {{ page_title }}
                </h1>
                <p class="text-caption white--text text--lighten-3 mb-0">
                  {{ $route.params.id ? 'עריכת פרטי מארז המתנה' : 'יצירת מארז מתנה חדש' }}
                </p>
              </div>
            </div>
          </div>

          <v-card-text class="pa-6">
            <!-- Skeleton Loader -->
            <v-row v-if="!edit_loaded">
              <v-col v-for="i in 5" :key="i" cols="6" sm="3">
                <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
              </v-col>
            </v-row>
            <div v-if="!edit_loaded">
              <v-col v-for="i in 3" :key="i" cols="12" sm="6">
                <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
              </v-col>
            </div>

            <!-- Form -->
            <v-form ref="form" v-if="edit_loaded">
              <Form
                :compare_dates="compare_dates"
                :item="item"
                @image-selected="onImageSelected"
              ></Form>

              <div class="d-flex justify-end mt-6">
                <v-btn
                  outlined
                  rounded
                  large
                  class="me-3"
                  @click="$router.push('/gift-campaigns')"
                >
                  <v-icon start>mdi-arrow-right</v-icon>
                  ביטול
                </v-btn>
                <v-btn
                  v-if="
                    this.$route.params.id
                      ? this.$store.getters.permission('gift_campaigns edit')
                      : this.$store.getters.permission('gift_campaigns create')
                  "
                  @click="save()"
                  color="indigo"
                  dark
                  rounded
                  large
                  width="200"
                  height="50"
                  :disabled="save_loader"
                  :loading="save_loader"
                  class="save-btn"
                >
                  <v-icon start>mdi-content-save</v-icon>
                  שמירה
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>

        <v-snackbar left v-model="snackbar_success">
          <p class="white--text">עודכן {{ page_title }}</p>
          <template v-slot:action>
            <v-icon color="success" class="ms-3">check_circle</v-icon>
          </template>
        </v-snackbar>

        <v-snackbar color="error" left v-model="snackbar_err">
          <p class="white--text">בבקשה לבדוק הכל</p>
          <template v-slot:action>
            <v-icon color="white" class="ms-3">error</v-icon>
          </template>
        </v-snackbar>
      </div>
    </div>
  </v-container>
</template>

<script>
import Form from "@/components/gift_campaigns/form";

export default {
  name: "GiftCampaign",
  data() {
    return {
      save_loader: false,
      edit_loaded: false,
      snackbar_success: false,
      snackbar_err: false,
      page_title: "",
      gift_image_file: null,
      item: {
        gift_name: "",
        gift_image: "",
        type: "cart_total",
        value_to_get_gift: 0,
        times: 1,
        start_date: null,
        end_date: null,
        status: true,
        brand_id: null,
      },
    };
  },
  components: { Form },
  computed: {
    compare_dates() {
      if (!this.item.start_date || !this.item.end_date) return true;
      return this.item.start_date <= this.item.end_date;
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.page_title = "עריכת מארז מתנה";
      this.get_item(this.$route.params.id);
    } else {
      this.page_title = "מארז מתנה חדש";
      this.edit_loaded = true;
    }
  },
  methods: {
    get_item(id) {
      this.$store
        .dispatch("public__request", {
          config: {
            url: `gift-campaigns/${id}`,
            method: "get",
          },
        })
        .then((res) => {
          const data = res.data.data;
          this.item = {
            gift_name: data.gift_name,
            gift_image: data.gift_image,
            type: data.type,
            value_to_get_gift: data.value_to_get_gift,
            times: data.times,
            start_date: data.start_date,
            end_date: data.end_date,
            status: data.status,
            brand_id: data.brand_id,
          };
          this.edit_loaded = true;
        });
    },
    onImageSelected(file) {
      this.gift_image_file = file;
    },
    save() {
      if (!this.$refs.form.validate()) return;
      if (this.save_loader) return;
      if (
        this.$route.params.id
          ? !this.$store.getters.permission("gift_campaigns edit")
          : !this.$store.getters.permission("gift_campaigns create")
      )
        return;

      this.save_loader = true;

      // Create FormData for file upload
      const formData = new FormData();
      formData.append('gift_name', this.item.gift_name);
      formData.append('type', this.item.type);
      formData.append('value_to_get_gift', this.item.value_to_get_gift);
      formData.append('times', this.item.times);
      formData.append('start_date', this.item.start_date);
      formData.append('end_date', this.item.end_date);
      formData.append('status', this.item.status ? 1 : 0);
      formData.append('brand_id', this.item.type === 'brand' ? this.item.brand_id : '');

      // Append image file if selected
      if (this.gift_image_file) {
        formData.append('gift_image', this.gift_image_file);
      }

      // For update, add _method: put to support file upload via POST
      if (this.$route.params.id) {
        formData.append('_method', 'put');
      }

      this.$store
        .dispatch("public__request", {
          config: {
            url: this.$route.params.id
              ? `gift-campaigns/${this.$route.params.id}`
              : "gift-campaigns",
            method: "post", // Always use POST for file uploads
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          },
          data: formData,
        })
        .then(() => {
          this.snackbar_success = true;
          this.save_loader = false;
          setTimeout(() => {
            this.$router.push("/gift-campaigns");
          }, 1000);
        })
        .catch((err) => {
          this.snackbar_err = true;
          this.save_loader = false;
          console.error('Save error:', err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.gift-form-card {
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.form-header {
  background: linear-gradient(135deg, #3949ab 0%, #5c6bc0 50%, #7986cb 100%);
}

.header-icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.save-btn {
  font-weight: 700;
  letter-spacing: 0.5px;
}
</style>